<div class="text-translations-block">
  <div class="collapsible-block">
    <div (click)="isCollapsibleBlockActive = !isCollapsibleBlockActive" [class.active-block]="isCollapsibleBlockActive"
         class="text-translations-content collapsible-item">{{ config?.title | translate }}</div>
    <div *ngIf="isCollapsibleBlockActive" class="text-translations text-translations-content">
      <div class="language-container" *ngFor="let language of languages">
        <div class="language-title">{{ language.title | translate }}</div>
        <app-form-file-uploader [value]="language.value" (onChanged)="emitValue()" [config]="language.config"></app-form-file-uploader>
      </div>
    </div>
  </div>
</div>
